module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_3_3.26a5207e.jpeg";